window.dataTable = function (options = {}) {
    const data = {
        name: "name" in options ? options.name : undefined,
        items: "data" in options ? options.data : [],
        searchInput: "searchInput" in options ? options.searchInput : "",
        pages: [],
        offset: "perPage" in options ? options.perPage : 10,
        pagination: {
            total: 0,
            lastPage:
                "data" in options
                    ? Math.ceil(options.data.length / options.perPage)
                    : 1,
            perPage: "perPage" in options ? options.perPage : 10,
            currentPage: 1,
            from: 1,
            to: "perPage" in options ? options.perPage : 10,
        },
        currentPage: 1,
        sorted: {
            field: "sortField" in options ? options.sortField : "id",
            rule: "sortDir" in options ? options.sortDir : "asc",
        },
        saveState: "saveState" in options ? options.saveState : false,
        serverside: "serverside" in options ? options.serverside : false,
        url: "url" in options ? options.url : "",
        filters: "filters" in options ? options.filters : "",
        interval: null,
        initData() {
            if (this.serverside) {
                this.fetchData();
            } else {
                this.items = JSON.parse(JSON.stringify(this.items));
                this.items = this.items.sort(
                    this.compareOnKey(this.sorted.field, this.sorted.rule)
                );
            }
        },
        search(value) {
            this.searchInput = value;
            this.currentPage = 1;
            this.fetchData();
        },
        toggleSort(field) {
            window.toggleSort(this.sorted, field);
            this.fetchData();
        },
        toggleCustomSort(field) {
            window.toggleCustomSort(this.sorted, field, 'status');
            this.fetchData();
        },
        changeView() {
            this.fetchData();
        },
        changeFilter() {
            this.fetchData();
        },
        hasPages() {
            if (this.pages) {
                return this.pages.length > 0;
            }
            return false;
        },
        setPage(page) {
            this.currentPage = page;
            this.fetchData();
        },
        nextPage() {
            if (this.currentPage < this.pagination.lastPage) {
                this.currentPage++;
                this.fetchData();
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.fetchData();
            }
        },
        fetchData(callback) {
            axios
                .get(this.url, {
                    params: {
                        page: this.currentPage,
                        perPage: this.pagination.perPage,
                        sorted: this.sorted,
                        search: this.searchInput,
                        filters: this.filters,
                    },
                })
                .then((response) => {
                    const data = response.data;
                    this.items = data.data;

                    if (!data.meta) {
                        data.meta = data;
                    }

                    if (!Array.isArray(data.data)) {
                        this.items = Object.values(data.data).map(
                            (dataItem) => dataItem
                        );
                    }

                    this.pagination.currentPage = data.meta.current_page;
                    this.pagination.lastPage = data.meta.last_page;
                    this.pagination.total = data.meta.total;
                    this.pagination.from = data.meta.from;
                    this.pagination.to = data.meta.to;
                    this.lastPage = Math.ceil(
                        data.meta.total / data.meta.per_page
                    );
                    this.pages = data.meta.links;
                })
                .then(() => {
                    if (callback) {
                        callback(this);
                    }
                });
        },
    };

    return data;
};
